<template>
<v-card class="panel" elevation="1">
    <div class="subscriptions">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.notes || "Notes" }} </h2>  
            </div>
             <div class="right" v-show="$page.props.p['members.payments.make']">
                <v-btn @click="addModal = true" color="primary" dark class="mr-4">
                    <v-icon small>mdi-plus</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.addNote || "Add note" }}</span>
                </v-btn>
            </div>
        </div>
        <v-dialog
        v-model="addModal"
        max-width="500px">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.addNote || "Add note" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="addModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                  <v-container>
                      <div class="fields">
                          <div class="grid">
                            <p class="custom-label">{{ $page.props.lang.note || 'Note' }}</p>
                            <v-textarea v-model="memberData.description" outlined dense
                            :hide-details="!responseErrors.description"
                            :error-messages="responseErrors.description" @focus="responseErrors.description=''" ></v-textarea>
                                <v-checkbox
                                v-model="memberData.is_private"
                                :label=privateLabel()
                                ></v-checkbox>
                          </div>   
                      </div>
                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="regular" @click="addModal = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                          <v-btn color="primary" @click="saveNote" :loading="saving">{{ $page.props.lang.save || "Save" }}</v-btn>
                      </v-card-actions>
                  </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
        v-model="editModal"
        max-width="500px">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.editNote || "Edit note" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="editModal = false"><v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
                <v-card-text>
                  <v-container>
                      <div class="fields">
                          <div class="grid">
                            <p class="custom-label">{{ $page.props.lang.note || 'Note' }}</p>
                            <v-textarea v-model="currentNote.description" outlined dense
                            :hide-details="!responseErrors.description"
                            :error-messages="responseErrors.description" @focus="responseErrors.description=''" ></v-textarea>
                             <v-checkbox
                              v-model="currentNote.is_private"
                              :label= privateLabel()
                              ></v-checkbox>
                          </div>   
                      </div>
                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="regular" @click="editModal = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                          <v-btn color="primary" @click="editNote">{{ $page.props.lang.save || "Save" }}</v-btn>
                      </v-card-actions>
                  </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-container v-if="memberData.notes != 0">
            <v-layout column wrap>
                <v-flex xs12 sm6 md4 lg3 v-for="note in memberData.notes" :key="note.id">
                        <v-card elevation="1" class="ma-2"> 
                            <v-row  justify="center" class="pl-3">  
                                 <v-row align="center" justify="end" class="pr-7 pt-4">
                                    <v-btn @click="openEditModal(note.id)" :id="'edit' + note.id" color="dark-grey" class="mt-1" icon right >
                                        <v-icon center>mdi-pencil</v-icon>
                                        <v-tooltip :activator="'#edit'+ note.id" bottom open-delay="500">
                                            <span>{{$page.props.lang.editNote || "Edit note"}}</span>
                                        </v-tooltip>    
                                    </v-btn>
                                    <v-btn @click="deleteNote(note.id, true)" :id="'delete' + note.id" class="delete-icon mt-1" icon right>
                                        <v-icon center>mdi-trash-can-outline</v-icon>
                                        <v-tooltip :activator="'#delete'+ note.id" bottom open-delay="500">
                                            <span>{{$page.props.lang.deleteNote || "Delete note"}}</span>
                                        </v-tooltip>
                                    </v-btn>
                                </v-row>  
                                <v-card-text class="pl-7">
                                     <p style="font-size: 17px">  {{ note.description }} </p>
                                </v-card-text>   
                            </v-row>    
                            <v-list-item>
                                <v-list-item-avatar size="30px">
                                <img :src="note.created_by.profile_photo_url+'?w=30'">
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <p class="pt-9" style="font-size: 15px"> {{ note.created_by.first_name + ' ' + note.created_by.last_name }} </p>
                                    <p style="text-align:right; font-size: 15px"> {{ note.created_at | fullDate }} </p>
                                </v-list-item-content>
                            </v-list-item>
                        </v-card> 
                </v-flex>      
            </v-layout>
        </v-container>
        <v-card v-else class="mx-auto my-12" max-width="500" outlined>
            <v-card-text v-html="$page.props.lang.no_active_notes || 'No added notes.<br> To add new note, press <b>add note</b> button.'" class="text-center "></v-card-text>
        </v-card>
        <ConfirmModal :title="$page.props.lang.confirmModalTitle || 'Confirmation'" :description="$page.props.lang.confirm_delete_note || 'Are you sure you want to delete this note?'" :open="deleteNotesModal" @no="deleteNotesModal = false" @yes="deleteNote(cNoteId, false)"></ConfirmModal>

    </div>
</v-card>
</template>


<script>
import AppLayout from '@/js/Layouts/AppLayout'
import MemberLayout from './Layouts/Default'
import ConfirmModal from '@/js/Components/ConfirmModal'
import EventBus from '@/js/eventbus'

export default{
    metaInfo(){
        return{
             title: this.$page.props.member.full_name + ' - ' + (this.$page.props.lang.title || "Notes")
        }
    },
    name:"MemberNotes",
    components: {
        ConfirmModal
    },

    layout: (h, page) => {
      return h(AppLayout, [
        h(MemberLayout, [page]),
      ])
    },
    props: {
        user:Object,
        member: Object,
        errors: Object,
        lang: Object,
        
    },
    data(){
      return {
        memberData: this.member,
        notesHeaders: [
                {text: this.lang.table_description || 'Description', value: 'description', sortable: false},
                {text: this.lang.table_action || 'Action', value: 'action', sortable: false}
            ],
        saving: false,
        addModal: false,
        editModal: false,
        note: {},
        messageObjects: [],
        deleteNotesModal: false,
        tablePage: 1,
        tablePageCount: 0,
        itemsPerPage: 8,
        currentNote: {},
        cNoteId: null,
        responseErrors: {} 
      }
    },

    watch: {
        member: function(value) {
            this.memberData = value
        },
        addModal: function(value) {
            if (value===false) {
                this.responseErrors = {}
                this.note = Object.assign({}, this.resetForm)
            }
        },

        editModal: function(value) {
            if (value===false) {
                this.responseErrors = {}
                this.note = Object.assign({}, this.resetForm)
            }
        }
        
    },

    methods: {
        privateLabel() {
           return (this.lang.private || 'Private');
         },
         
        saveNote() {
            let notePack = {
                notable_id: this.member.id,
                description: this.member.description,
                is_private: this.member.is_private,
                created_by: this.member.created_by
            };
            this.saving = true;
            axios.post('/backoffice/members/addNote', notePack)
                .then(response => {
                    this.saving = false;
                    if(response.data.status==="OK") {
                      
                        this.$inertia.reload({only:['member']})
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                      this.addModal = false;
                    }
                })
                .catch(error => {
                    this.saving = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                });

                
        },
    
        openEditModal(id){
            
            axios.get('/backoffice/members/getNote/'+ id)
                .then(response => {
                    if(response.data.status === "OK"){
                        this.editModal = true
                        this.currentNote = response.data.note
                    }else{
                        alert("Server error.")
                    }
                })
        },

        editNote(){
            let notePack = {
                id: this.currentNote.id,
                member_id: this.currentNote.member_id,
                description: this.currentNote.description,
                is_private: this.currentNote.is_private,
                organization_id: this.currentNote.organization_id,
                created_by: this.currentNote.created_by
            };
            axios.post('/backoffice/members/updateNote', notePack)
                .then(response => {
                    if(response.data.status==="OK") {
                        this.$inertia.reload({only:['member']})
                        EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                      this.editModal = false
                    }
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                });

                
        },


        deleteNote(id, showConfirmation) {
            if(showConfirmation){
                this.deleteNotesModal = true;
                this.cNoteId = id;
                return;
            }
            axios.post('/backoffice/members/deleteNote', {id: id})
                .then(response => {
                     this.deleteNotesModal = false;
                    if(response.data.status==="OK") {
                        this.$inertia.reload({only:['member']})
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(function (error) {
                     this.deleteNotesModal = false;
                     EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                })
        }

}

}

</script>